import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import './styles/thanks.scss';

class ChatThanks extends Component {
  static propTypes = {
    timeout: PropTypes.number,
    label: PropTypes.string.isRequired,
    reload: PropTypes.bool,
  };
  componentDidMount() {
    if (this.props.reload) {
      setTimeout(() => window.location.reload(), this.props.timeout * 1000);
    }
  }
  render() {
    return (
      <div className="chat-thanks-wraper">
        <h4>{this.props.label}</h4>
      </div>
    );
  }
}

export default ChatThanks;



// WEBPACK FOOTER //
// ./components/chat/Thanks.js